import { useCallback, useContext } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Filters } from '../../../hooks/products';
import { useSearchFocus } from '../../../hooks/use-search-focus';
import { defaultProductSearchPlaceholders, SearchInput } from '../../search-input';

const placeholders = [...defaultProductSearchPlaceholders, 'Search by vendor, e.g. SGWS'];

export function SearchField({ grouped = false }: { grouped?: boolean } = {}) {
  const { filters, setFilters } = useContext(ProductTableContext);
  const { query } = filters;
  const searchReference = useSearchFocus();

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setFilters((prev: Filters) => ({ ...prev, query: event.target.value }));
    },
    [setFilters]
  );

  return (
    <SearchInput
      value={query ?? ''}
      onChange={onChange}
      inputRef={searchReference}
      placeholders={placeholders}
      shortcut="meta+f"
      grouped={grouped}
    />
  );
}
